import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Modal } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { useAlert } from "react-alert";

export default function CrudDeleteModal({ returnUrl, service, match }) {
    const { params } = match;

    const alert = useAlert();
    const [deleting, setDeleting] = useState(false);
    const [deleted, setDeleted] = useState(false);

    async function handleDelete(id) {
        setDeleting(true);
        
        try {
            const { error, messages } = await service.delete({ id: params.deleteId });

            messages.forEach((msg) =>
                msg.code > 2999 ? alert.error(msg.description) :
                msg.code > 1999 ? alert.show(msg.description, {type: 'warning'}) :
                msg.code >  999 ? alert.show(msg.description) :
                alert.success(msg.description) 
            );

            if(!error) {
                setDeleted(true);
            }
        } catch(err) {
            alert.error(err.message);
            console.trace(err);
        } finally {
            setDeleting(false);
        }
    }

    if(deleted) {
        return <Redirect to={returnUrl}/>
    }

    return (
        <Modal show={true}>
            <Modal.Header>
                Excluir
            </Modal.Header>
            <Modal.Body>
                <p>
                    Tem certeza que deseja exluir esse registro?
                </p>
                <div className="d-flex w-100 justify-content-between">
                    <Button as={NavLink} variant="secondary" size="sm" to={returnUrl}>
                        <FontAwesomeIcon icon="fa-reply"/> Cancelar
                    </Button>
                    <Button variant="danger" size="sm" onClick={handleDelete} disabled={deleting}>
                        <FontAwesomeIcon icon={"fa-trash"}/> Excluir
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}